import { render, staticRenderFns } from "./playerIPLimit.vue?vue&type=template&id=27aa7000&scoped=true"
import script from "./playerIPLimit.vue?vue&type=script&lang=js"
export * from "./playerIPLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa7000",
  null
  
)

export default component.exports